(function () {
  "use strict";

  if (window.PersonalizePilotLayersLoaded) return;
  window.PersonalizePilotLayersLoaded = true;

  function parseJson(value) {
    if (!value) return null;
    try {
      return JSON.parse(value);
    } catch (_error) {
      return null;
    }
  }

  function element(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  }

  function matchesRule(rule, selected) {
    var current = selected[rule.sourceLayerId] || "";
    var optionIds = Array.isArray(rule.optionIds) ? rule.optionIds : [];
    if (rule.operator === "selected") return Boolean(current);
    if (rule.operator === "not_selected") return !current;
    if (rule.operator === "not_equals") return optionIds.indexOf(current) === -1;
    return optionIds.indexOf(current) !== -1;
  }

  function optionAvailable(option, selected, variantId) {
    if (option.active === false) return false;
    if (
      Array.isArray(option.variantIds) &&
      option.variantIds.length &&
      option.variantIds
        .map(function (id) {
          return String(id).split("/").pop();
        })
        .indexOf(String(variantId || "").split("/").pop()) === -1
    ) {
      return false;
    }
    return !(option.rules || []).some(function (rule) {
      return rule.effect === "disable_option" && matchesRule(rule, selected);
    });
  }

  function normalizeText(value, settings) {
    var result = String(value || "").replace(/\r\n?/g, "\n");
    if (!settings.multiline) result = result.replace(/\s*\n+\s*/g, " ");
    result = result.slice(0, Number(settings.maxCharacters || 40));
    if (settings.letterCase === "uppercase") result = result.toLocaleUpperCase("de-DE");
    if (settings.letterCase === "lowercase") result = result.toLocaleLowerCase("de-DE");
    if (settings.allowedCharacters) {
      try {
        result = result.replace(
          new RegExp("[^" + settings.allowedCharacters + "]", "gu"),
          "",
        );
      } catch (_error) {
        // Merchant validation reports invalid expressions before publication.
      }
    }
    return result;
  }

  function attach(widget) {
    if (!widget || widget.dataset.personalizePilotLayersAttached === "true") return;
    var config = parseJson(widget.dataset.layerConfigurator);
    if (!config || !config.enabled || !Array.isArray(config.layers)) return;
    widget.dataset.personalizePilotLayersAttached = "true";

    var fields = widget.querySelector(".personalize-pilot-widget__fields");
    var previewSource = widget.querySelector(
      ".personalize-pilot-widget__preview-source",
    );
    if (!fields || !previewSource) return;

    var selected = {};
    var texts = {};
    var controls = {};
    var currentVariant = function () {
      var form =
        widget.closest("form[action*='/cart/add']") ||
        widget.querySelector("form[action*='/cart/add']");
      var variantInput =
        (form && form.querySelector("[name='id']")) ||
        document.querySelector("form[action*='/cart/add'] [name='id']");
      return variantInput ? variantInput.value : "";
    };

    config.layers.forEach(function (layer) {
      if (!layer.active) return;
      if (layer.kind === "image") {
        var fallback = (layer.options || []).find(function (option) {
          return option.id === layer.defaultOptionId && option.active !== false;
        }) || (layer.options || []).find(function (option) {
          return option.active !== false;
        });
        if (fallback) selected[layer.id] = fallback.id;
      } else {
        texts[layer.id] = "";
      }
    });

    var preview = element("div", "personalize-pilot-layers-preview");
    preview.setAttribute("aria-label", "Layer-Vorschau");
    preview.style.aspectRatio =
      Number(config.canvasWidthPx || 1) + " / " + Number(config.canvasHeightPx || 1);
    if (config.backgroundMode === "color") {
      preview.style.backgroundColor = config.backgroundColor || "#ffffff";
    }
    previewSource.appendChild(preview);
    var previewNodes = {};

    var panel = element("section", "personalize-pilot-layers-panel");
    panel.setAttribute("aria-labelledby", "PersonalizePilotLayersTitle-" + config.id);
    var heading = element("div", "personalize-pilot-widget__field-group-title");
    heading.id = "PersonalizePilotLayersTitle-" + config.id;
    heading.textContent = config.name || "Motiv zusammenstellen";
    panel.appendChild(heading);
    fields.insertBefore(panel, fields.firstChild);

    var configurationInput = document.createElement("input");
    configurationInput.type = "hidden";
    configurationInput.name = "properties[_personalize_pilot_layer_configuration]";
    panel.appendChild(configurationInput);

    var summaryInput = document.createElement("input");
    summaryInput.type = "hidden";
    summaryInput.name = "properties[Motiv-Konfiguration]";
    panel.appendChild(summaryInput);

    var idInput = document.createElement("input");
    idInput.type = "hidden";
    idInput.name = "properties[_personalize_pilot_layer_configurator]";
    idInput.value = String(config.id || "");
    panel.appendChild(idInput);

    var versionInput = document.createElement("input");
    versionInput.type = "hidden";
    versionInput.name = "properties[_personalize_pilot_layer_version]";
    versionInput.value = String(config.version || 1);
    panel.appendChild(versionInput);

    function removePreviewNode(layerId) {
      var node = previewNodes[layerId];
      if (node) node.remove();
      delete previewNodes[layerId];
    }

    function getImagePreviewNode(layer) {
      var existing = previewNodes[layer.id];
      if (existing && existing.tagName === "IMG") return existing;
      removePreviewNode(layer.id);
      var image = document.createElement("img");
      image.alt = "";
      image.loading = "eager";
      image.dataset.layerPreviewId = layer.id;
      image.addEventListener("error", function () {
        image.hidden = true;
        var status = widget.querySelector("[data-design-save-status]");
        if (status) {
          status.hidden = false;
          status.textContent =
            "Eine Motivebene konnte nicht geladen werden. Bitte wähle eine andere Option.";
        }
      });
      previewNodes[layer.id] = image;
      preview.appendChild(image);
      return image;
    }

    function getTextPreviewNode(layer) {
      var existing = previewNodes[layer.id];
      if (existing && existing.tagName === "SPAN") return existing;
      removePreviewNode(layer.id);
      var textNode = element("span", "personalize-pilot-layers-preview__text");
      textNode.dataset.layerPreviewId = layer.id;
      previewNodes[layer.id] = textNode;
      preview.appendChild(textNode);
      return textNode;
    }

    function render() {
      var summary = [];
      var renderedLayerIds = {};
      config.layers
        .slice()
        .sort(function (left, right) {
          return Number(left.zIndex || 0) - Number(right.zIndex || 0);
        })
        .forEach(function (layer) {
          if (!layer.active) return;
          var hidden = (layer.options || []).some(function (option) {
            return (option.rules || []).some(function (rule) {
              return rule.effect === "hide_layer" && matchesRule(rule, selected);
            });
          });
          var field = controls[layer.id];
          if (field) field.hidden = hidden;
          if (hidden) {
            removePreviewNode(layer.id);
            return;
          }

          if (layer.kind === "image") {
            var option = (layer.options || []).find(function (candidate) {
              return candidate.id === selected[layer.id];
            });
            if (!option || !option.sourceUrl) {
              removePreviewNode(layer.id);
              return;
            }
            var image = getImagePreviewNode(layer);
            image.style.zIndex = String(layer.zIndex || 0);
            image.hidden = false;
            if (image.getAttribute("src") !== option.sourceUrl) {
              image.src = option.sourceUrl;
            }
            renderedLayerIds[layer.id] = true;
            summary.push(layer.name + ": " + option.label);
          } else if (layer.text) {
            var value = normalizeText(texts[layer.id], layer.text);
            if (!value) {
              removePreviewNode(layer.id);
              return;
            }
            var textNode = getTextPreviewNode(layer);
            textNode.textContent = value;
            textNode.style.zIndex = String(layer.zIndex || 0);
            textNode.style.left = Number(layer.text.xPercent || 50) + "%";
            textNode.style.top = Number(layer.text.yPercent || 50) + "%";
            textNode.style.width = Number(layer.text.widthPercent || 80) + "%";
            textNode.style.color = layer.text.color || "#111111";
            textNode.style.fontFamily = layer.text.fontFamily || "inherit";
            textNode.style.fontSize =
              "clamp(12px, " +
              Math.max(1, Number(layer.text.fontSizePx || 48) / 10) +
              "vw, " +
              Math.max(12, Number(layer.text.fontSizePx || 48) / 2) +
              "px)";
            textNode.style.lineHeight = String(layer.text.lineHeight || 1.2);
            textNode.style.textAlign = layer.text.align || "center";
            textNode.style.whiteSpace = layer.text.multiline ? "pre-wrap" : "nowrap";
            textNode.style.transform =
              "translate(-50%, -50%) rotate(" +
              Number(layer.text.rotation || 0) +
              "deg)";
            renderedLayerIds[layer.id] = true;
            summary.push(layer.name + ": " + value);
          }
        });
      Object.keys(previewNodes).forEach(function (layerId) {
        if (!renderedLayerIds[layerId]) removePreviewNode(layerId);
      });

      Object.keys(controls).forEach(function (layerId) {
        var control = controls[layerId];
        Array.prototype.forEach.call(
          control.querySelectorAll("[data-layer-option]"),
          function (button) {
            var layer = config.layers.find(function (candidate) {
              return candidate.id === layerId;
            });
            var option = layer && layer.options.find(function (candidate) {
              return candidate.id === button.dataset.layerOption;
            });
            var available =
              button.dataset.layerOption === ""
                ? true
                : option && optionAvailable(option, selected, currentVariant());
            button.disabled = !available;
            button.setAttribute(
              "aria-pressed",
              selected[layerId] === button.dataset.layerOption ? "true" : "false",
            );
          },
        );
      });

      configurationInput.value = JSON.stringify({
        configuratorId: config.id,
        configuratorVersion: Number(config.version || 1),
        selectedOptionIds: selected,
        textValues: texts,
      });
      summaryInput.value = summary.join(" · ").slice(0, 1000);
    }

    configurationInput.addEventListener("input", function () {
      var restored = parseJson(configurationInput.value);
      if (
        !restored ||
        restored.configuratorId !== config.id ||
        Number(restored.configuratorVersion || 0) !== Number(config.version || 1)
      ) {
        return;
      }
      selected = Object.assign({}, selected, restored.selectedOptionIds || {});
      texts = Object.assign({}, texts, restored.textValues || {});
      Object.keys(texts).forEach(function (layerId) {
        var input =
          controls[layerId] &&
          controls[layerId].querySelector("input[type='text'],textarea");
        if (input) input.value = texts[layerId] || "";
      });
      render();
    });

    config.layers.forEach(function (layer) {
      if (!layer.active || !layer.customerEditable) return;
      var group = element("fieldset", "personalize-pilot-layers-field");
      controls[layer.id] = group;
      var legend = element(
        "legend",
        "",
        layer.name + (layer.required ? " *" : ""),
      );
      group.appendChild(legend);

      if (layer.kind === "image") {
        var options = element("div", "personalize-pilot-layers-options");
        if (!layer.required) {
          var noneButton = element("button", "personalize-pilot-layers-option");
          noneButton.type = "button";
          noneButton.dataset.layerOption = "";
          noneButton.setAttribute("aria-pressed", selected[layer.id] ? "false" : "true");
          noneButton.appendChild(element("span", "", "Ohne"));
          noneButton.addEventListener("click", function () {
            delete selected[layer.id];
            render();
          });
          options.appendChild(noneButton);
        }
        (layer.options || []).forEach(function (option) {
          if (!option.active) return;
          var button = element("button", "personalize-pilot-layers-option");
          button.type = "button";
          button.dataset.layerOption = option.id;
          button.setAttribute("aria-pressed", selected[layer.id] === option.id ? "true" : "false");
          var image = document.createElement("img");
          image.src = option.thumbnailUrl || option.sourceUrl;
          image.alt = "";
          image.loading = "lazy";
          button.appendChild(image);
          button.appendChild(element("span", "", option.label));
          if (Number(option.priceAdjustment || 0) > 0) {
            button.appendChild(
              element(
                "small",
                "",
                "+ " + Number(option.priceAdjustment).toFixed(2).replace(".", ",") + " €",
              ),
            );
          }
          button.addEventListener("click", function () {
            if (button.disabled) return;
            selected[layer.id] = option.id;
            render();
          });
          options.appendChild(button);
        });
        group.appendChild(options);
      } else if (layer.text) {
        var input = document.createElement(layer.text.multiline ? "textarea" : "input");
        if (!layer.text.multiline) input.type = "text";
        input.placeholder = layer.text.placeholder || "";
        input.maxLength = Number(layer.text.maxCharacters || 40);
        input.required = Boolean(layer.required);
        input.setAttribute("aria-label", layer.name);
        input.addEventListener("input", function () {
          var normalized = normalizeText(input.value, layer.text);
          if (input.value !== normalized) input.value = normalized;
          texts[layer.id] = normalized;
          render();
        });
        group.appendChild(input);
      }
      panel.appendChild(group);
    });

    var reset = widget.querySelector("[data-personalization-reset]");
    if (reset) {
      reset.addEventListener("click", function () {
        selected = {};
        texts = {};
        config.layers.forEach(function (layer) {
          if (layer.kind === "image" && layer.defaultOptionId) {
            selected[layer.id] = layer.defaultOptionId;
          } else if (layer.kind === "text") {
            texts[layer.id] = "";
            var input = controls[layer.id] && controls[layer.id].querySelector("input,textarea");
            if (input) input.value = "";
          }
        });
        render();
      });
    }
    document.addEventListener("change", function (event) {
      if (event.target && event.target.name === "id") render();
    });
    render();
  }

  function attachAll() {
    document
      .querySelectorAll("[data-personalize-pilot-widget]")
      .forEach(attach);
  }

  window.PersonalizePilotLayersAttachAll = attachAll;
  attachAll();
  document.addEventListener("shopify:section:load", attachAll);
})();
